<template>
  <div class="search-result">
    <div class="search-result__subject">
      <img
        v-if="item.thumbnail"
        :src="item.thumbnail"
        class="search-result__subject-thumbnail"
        alt=""
        width="24"
        height="24"
      />
      <h2
        class="search-result__subject-title text-tiny"
        :style="{ color: textColour }"
      >
        <span class="search-result__topic">
          {{ item.learning_area ? item.subject_topic : contentType }}
        </span>
        <span
          v-if="item.learning_area && type"
          class="search-result__type text-x-tiny"
        >
          {{ type }}
        </span>
      </h2>
    </div>
    <h3
      v-if="item.title"
      class="search-result__title text-small"
    >
      <AisSnippet
        attribute="title"
        :hit="item"
      />
    </h3>
    <div
      v-if="item.content_fields"
      class="search-result__content-wrapper"
    >
      <img
        v-if="item.content_thumbnail"
        :src="item.content_thumbnail"
        class="search-result__thumbnail"
        alt=""
      />
      <img
        v-if="item.file_type"
        :src="`/themes/custom/ncea/dist/images/` + `icon_file_${fileType}.svg`"
        class="search-result__thumbnail-icon"
      />
      <img
        v-if="item.paragraph_type === 'Downloads' && !item.file_type"
        src="/themes/custom/ncea/dist/images/icon_file_multi.svg"
        class="search-result__thumbnail-icon"
      />
      <img
        v-if="item.paragraph_type === 'Audio'"
        src="/themes/custom/ncea/dist/images/icon_headphones.svg"
        class="search-result__thumbnail-icon"
      />
      <AisSnippet
        class="search-result__content text-small"
        attribute="content_fields"
        :hit="item"
      />
    </div>
    <div
      v-if="item.related_tags?.length"
      class="search-result__related-tags"
    >
      <span
        v-for="tag in item.related_tags"
        :key="tag"
        class="search-result__related-tag text-x-tiny"
      >
        {{ tag }}
      </span>
    </div>
  </div>
</template>

<script>
import { AisSnippet } from 'vue-instantsearch/vue3/es';
import { FILE_TYPES } from '../../utils/utils';

export default {
  name: 'SiteSearchResult',
  components: {
    AisSnippet,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    textColour() {
      return this.item.secondary_colour ?? '#000';
    },
    type() {
      if (this.item.content_type === 'Basic Page') {
        return this.item.subject_topic;
      }
      return this.contentType ?? '';
    },
    fileType() {
      return FILE_TYPES.get(this.item.file_type) ?? 'unknown';
    },
    contentType() {
      if (this.item.content_type === 'Basic Page') {
        return 'About NCEA';
      }
      return this.item.content_type.split(' - ')[1] || this.item.content_type.split(' - ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;
  margin-top: 1rem;
  border-bottom: $border-width solid $color-light-grey-s4;

  @include hover-focus-active {
    border-color: $color-blue;
  }

  &__subject {
    display: flex;
    align-items: center;
    gap: 0.833rem;
    text-transform: uppercase;
  }

  &__subject-title {
    font-weight: bold;
    line-height: 1.25;
    margin: 0;
  }

  &__title {
    font-weight: $font-weight-medium;
    margin: 0;
  }

  &__topic {
    margin-right: 0.5rem;
  }

  &__type {
    text-transform: uppercase;
    color: $color-charcoal-xlight-s3;
    word-spacing: 0.17rem;
    padding-left: 0.5rem;
    border-left: $border-width solid $color-charcoal-xlight-s3;
  }

  &__content-wrapper {
    display: flex;
    gap: 1.67rem;
    align-items: center;

    @include education-breakpoint-mobile-down {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__thumbnail {
    width: 10rem;
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }

  &__thumbnail-icon {
    height: 2.7rem;
    padding: 1.5rem 4.2rem;
  }

  &__related-tags {
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    margin-top: 0.5rem;
  }

  &__related-tag {
    color: $color-charcoal-mid;
    background-color: $color-xlight-grey;
    padding: 0.16rem 0.55rem;
    border-radius: 0.27rem;
    border: $border-width solid $color-pale-grey;
    white-space: nowrap;
  }
}
</style>
